import { render, staticRenderFns } from "./Func53Pendencias.vue?vue&type=template&id=a096d8f6"
import script from "./Func53Pendencias.vue?vue&type=script&lang=js"
export * from "./Func53Pendencias.vue?vue&type=script&lang=js"
import style0 from "./Func53Pendencias.vue?vue&type=style&index=0&id=a096d8f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports